import React from 'react';
import PropTypes from 'prop-types';
const FooterLinks = ({
  children = null
}) => children && /*#__PURE__*/React.createElement("ul", {
  className: "footer-menu list--unstyled"
}, children);
FooterLinks.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};
export default FooterLinks;
//# sourceMappingURL=links.js.map